<script setup lang="ts">
import { useToastStore } from '@/stores/toast.store';

const toasts = useToastStore();
</script>

<template>
  <div class="j-toast-stack" role="status" aria-live="polite">
    <transition-group name="toast">
      <div
        v-for="msg in toasts.messages"
        :key="msg.id"
        class="j-toast"
        :data-severity="msg.severity"
        @click="toasts.dismiss(msg.id)"
      >
        <strong>{{ msg.summary }}</strong>
        <span v-if="msg.detail" class="j-toast-detail">{{ msg.detail }}</span>
      </div>
    </transition-group>
  </div>
</template>

<style scoped>
.j-toast-stack {
  position: fixed;
  top: calc(var(--layout-topbar-height) + var(--space-3));
  right: var(--space-5);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  max-width: 360px;
}
.j-toast {
  background: var(--color-bg-elevated);
  color: var(--color-text-primary);
  border: 1px solid var(--color-border-base);
  border-left-width: 4px;
  border-radius: var(--radius-md);
  padding: var(--space-3) var(--space-4);
  box-shadow: var(--shadow-md);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.j-toast[data-severity='success'] {
  border-left-color: var(--color-success);
  background: var(--color-success-bg);
  color: var(--color-success);
}
.j-toast[data-severity='info'] {
  border-left-color: var(--color-info);
  background: var(--color-info-bg);
  color: var(--color-info);
}
.j-toast[data-severity='warn'] {
  border-left-color: var(--color-warning);
  background: var(--color-warning-bg);
  color: var(--color-warning);
}
.j-toast[data-severity='error'] {
  border-left-color: var(--color-danger);
  background: var(--color-danger-bg);
  color: var(--color-danger);
}
.j-toast-detail {
  font-size: var(--font-size-sm);
  color: inherit;
  opacity: 0.85;
}
.toast-enter-from,
.toast-leave-to {
  opacity: 0;
  transform: translateX(20px);
}
.toast-enter-active,
.toast-leave-active {
  transition: opacity 180ms ease, transform 180ms ease;
}
</style>
